<script>
  import { push } from 'svelte-spa-router';
  import { Ban } from '../lib/icons/index.js';
  import Layout from '../components/Layout.svelte';
  import FeatureBadge from '../components/FeatureBadge.svelte';
  import { featureKind, isKnownFeature } from '../lib/features.js';
  import { t } from '../i18n/index.js';

  /** Route parameters: `/funzione-non-disponibile/:feature`. */
  export let params = {};

  $: key = params?.feature;
  $: known = isKnownFeature(key);
  $: kind = known ? featureKind(key) : null;
</script>

<Layout>
  <div class="flex flex-col items-center text-center py-20" data-testid="feature-unavailable">
    <Ban size={40} class="mb-4 text-action/70" aria-hidden="true" />
    <h1 class="section-title">{$t('features.unavailable.title')}</h1>
    {#if known}
      <p class="text-heading text-sm font-bold mt-1">
        {$t(`features.${key}.label`)}
        <FeatureBadge {kind} hint={false} />
      </p>
      <p class="text-muted text-sm max-w-md mt-2">
        {$t(kind === 'experimental' ? 'features.unavailable.bodyExperimental' : 'features.unavailable.bodyDedicated',
          { label: $t(`features.${key}.label`) })}
      </p>
      <div class="next-step mt-6 text-left max-w-md text-sm">
        <p class="font-bold text-heading">{$t('features.unavailable.whatIs')}</p>
        <p class="mt-1 text-muted">{$t(`features.${key}.description`)}</p>
      </div>
    {:else}
      <p class="text-muted text-sm max-w-md">{$t('features.unavailable.body')}</p>
    {/if}
    <button class="btn btn-primary mt-6" on:click={() => push('/')}>{$t('features.unavailable.home')}</button>
  </div>
</Layout>
